import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { retryUnlessRefused } from "@/lib/api-client";
import { AnalyticsRange, CallAnalyticsParams, getCallAnalytics } from "./analytics.service";

// Whole-workspace analytics for the Analytics page.
//  - range null asks nothing: a custom window is half-picked or refused.
//  - keepPreviousData: changing a filter keeps the current numbers on screen
//    (dimmed) until the new ones arrive instead of unmounting the page.
//  - staleTime: the aggregate scans the whole window server-side; don't re-run
//    it on every window focus. A minute is plenty for a reporting view.
export const useCallAnalytics = (
  workspaceId: string | undefined,
  { range, ...filters }: Omit<CallAnalyticsParams, "workspaceId" | "range"> & { range: AnalyticsRange | null },
) =>
  useQuery({
    queryKey: ["call-analytics", workspaceId, { range, ...filters }],
    queryFn: () => getCallAnalytics({ workspaceId: workspaceId!, range: range!, ...filters }),
    enabled: !!workspaceId && range !== null,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
    retry: retryUnlessRefused,
  });
